import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=auth

  useEffect(() => {
    const token = localStorage.getItem("ms_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("ms_token");
        setUser(false);
      });
  }, []);

  const login = async (email, password, code) => {
    const { data } = await api.post("/auth/login", { email, password, code });
    if (data.twofa_required) return { twofaRequired: true };
    localStorage.setItem("ms_token", data.token);
    setUser(data.user);
    return { twofaRequired: false };
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("ms_token", data.token);
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem("ms_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { formatApiError };
